import Link from "next/link";
import React from "react";

import { useUser } from "@/context/AuthContext";
import Banner from "@/components/Landing/Banner";

const AboutUs = () => {
  const { isLogin } = useUser();
  return (
    <div className=" my-3 mx-3 lg:mx-7 lg:my-4 surface-card border-2 border-solid surface-border surface-section p-4">
      <h1 className="text-primary text-5xl">About portfolii </h1>
      <p className="m-0 text-base text-primary text-left text-700">
        Welcome to portfolii, where your career story takes center stage. We're
        passionate about changing the way you present yourself professionally,
        going beyond traditional resumes to celebrate your unique journey.
      </p>
      <br />
      <h2 className="text-primary text-2xl">Our Mission </h2>
      <p className="m-0 text-base text-primary text-left text-700">
        At portfolii, our mission is clear: to empower individuals on their
        career journeys. We believe that every career path is a story waiting to
        be told. Our platform provides a dynamic and personalized space where
        you can craft compelling narratives, connect with opportunities, and
        unlock your full potential. We're here to ensure that your journey is
        heard and celebrated, no matter where it leads.
      </p>
      <br />
      <h2 className="text-primary text-2xl">Our Vision </h2>
      <p className="m-0 text-base text-primary text-left text-700">
        Our vision is to revolutionize the world of job applications. We
        envision a future where career stories stand out, connecting talent with
        opportunities in a more authentic and impactful way. portfolii strives
        to be the global leader in storytelling-based job application platforms,
        shaping the future of career advancement. We're dedicated to helping you
        make your story the heart of your success.
      </p>
      <br />

      <h2 className="text-primary text-2xl">Our Values </h2>
      <div className="flex flex-column">
        <div>
          <h4 className="inline text-primary">Authenticity:</h4>{" "}
          <p className="mt-2 inline text-primary">
            We celebrate your unique journey and believe that authenticity is
            the key to success.
          </p>
        </div>
        <br />
        <div className="">
          <h4 className="inline text-primary">Inclusivity:</h4>{" "}
          <p className="mt-2 inline text-primary">
            We're committed to creating an inclusive platform where everyone's
            story matters.
          </p>
        </div>
        <br />
        <div>
          <h4 className="inline text-primary">Innovation:</h4>{" "}
          <p className="mt-2 inline text-primary">
            We're driven by innovation and technology to provide you with the
            best tools for career advancement.
          </p>
        </div>
        <br />
        <div>
          <h4 className="inline text-primary">Empowerment:</h4>{" "}
          <p className="mt-2 inline text-primary">
            We empower you to take control of your professional narrative and
            reach your goals.
            <br />
            <br />
          </p>
        </div>
        <div className="mt-6">
          <Banner />
        </div>
        <div>
          Icons by{" "}
          <Link href="https://icons8.com/" target="_blank">
            Icons8
          </Link>{" "}
        </div>
        <br />
      </div>
    </div>
  );
};

export default AboutUs;
